import { render, staticRenderFns } from "./ProductModel.vue?vue&type=template&id=b1de4342&scoped=true&"
import script from "./ProductModel.vue?vue&type=script&lang=js&"
export * from "./ProductModel.vue?vue&type=script&lang=js&"
import style0 from "./ProductModel.vue?vue&type=style&index=0&id=b1de4342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1de4342",
  null
  
)

export default component.exports